module.exports = __webpack_public_path__ + "img/9.7b1670e7.png";